import React, { Component } from 'react'

import {getUser, createGame, theGame} from '../functions/firebase'
import Loading from './componnets/Loading'
export default class HostGame extends Component {
    state={ 
        gameLink:null
    }

    componentDidMount(){
        createGame()
    .then(data =>{

        var key = theGame(data)
        this.props.history.push('/nakbah/'+key)
        
        
    })
        
    }


    render() {
        return (
            <div>
              <Loading/> 
            </div>
        )
    }
}
